import { render } from "./AcademyPage.vue?vue&type=template&id=310d7d70"
import script from "./AcademyPage.vue?vue&type=script&lang=js"
export * from "./AcademyPage.vue?vue&type=script&lang=js"

import "./AcademyPage.vue?vue&type=style&index=0&id=310d7d70&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__